import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ForthPayment from '@fielded/forth-payment'

const mapStateToProps = ({ auth: { user } }) => ({ user })

const FieldPay = connect(mapStateToProps)(ForthPayment)

FieldPay.PropTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired
  })
}

export default () => <FieldPay />



// WEBPACK FOOTER //
// ./src/payments/PaymentContainer.js